<template>
  <beautiful-chat
    class="v-chat-box px"
    :class="{ mobile: isMobile }"
    :placeholder="'请输入...'"
    :participants="participants"
    :onMessageWasSent="onMessageWasSent"
    :messageList="messageList"
    :newMessagesCount="newMessagesCount"
    :isOpen="isChatOpen"
    :close="() => (isChatOpen = false)"
    :open="() => (isChatOpen = true)"
    :showEmoji="false"
    :showFile="false"
    :showEdition="false"
    :showDeletion="false"
    :showLauncher="true"
    :showCloseButton="true"
    :showTypingIndicator="loading ? ' ' : ''"
    :colors="colors"
    :alwaysScrollToBottom="true"
    :disableUserListToggle="true"
    :messageStyling="true"
    @onType="() => {}"
    @edit="() => {}"
  />
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "CChatBox",
  data() {
    return {
      token: localStorage.getItem("ai-token") || "",
      phone: "",
      recorder: {},
      isRecording: false,
      participants: [{ id: "am", name: "AM Master" }],
      messageList: [],
      newMessagesCount: 0,
      isChatOpen: false,
      loading: false,
      text: "",
      timer: 0,
      colors: {
        header: { bg: "#4e8cff", text: "#ffffff" },
        launcher: { bg: "#4e8cff" },
        messageList: { bg: "#ffffff" },
        sentMessage: { bg: "#4e8cff", text: "#ffffff" },
        receivedMessage: { bg: "#eaeaea", text: "#222222" },
        userInput: { bg: "#f4f7f9", text: "#565867" },
      },
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState("app", {
      isMobile: "isMobile",
      isCN: "isCN",
    }),
    ...mapState("assets", {
      images: "images",
    }),
  },
  methods: {
    initInput() {
      setTimeout(() => {
        const input = document.querySelector(".sc-user-input--text");
        if (input) {
          input.onpaste = (event) => {
            event.preventDefault();
            const text = (event.clipboardData || window.clipboardData).getData(
              "text/plain"
            );
            document.execCommand("insertHTML", false, text);
          };
          input.addEventListener("input", () => {
            if (input.innerText.length > 2000) {
              const text = input.innerText || "";
              input.innerText = "";
              document.execCommand("insertHTML", false, text.slice(0, 2000));
            }
          });
        }
      }, 1000);
    },
    onMessageWasSent(message) {
      this.messageList = [...this.messageList, message];
      this.loading = true;
      // if (message.data.text.startsWith("/login")) {
      //   this.sendCode(message.data.text.replace("/login", "").trim());
      // } else if (this.phone && /\d{6}/.test(message.data.text.trim())) {
      //   this.login(message.data.text.trim());
      // } else if (message.data.text.startsWith("/logout")) {
      //   this.logout();
      // } else if (message.data.text.startsWith("/add")) {
      //   this.addPrompt(message.data.text.replace("/add", "").trim());
      // } else {
      this.chat(message.data.text);
      // }
    },
    sendCode(phone) {
      const mobileRe = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      if (!mobileRe.test(phone)) {
        this.loading = false;
        this.messageList = [
          ...this.messageList,
          {
            type: "text",
            author: "assistant",
            data: { text: "请输入正确的手机号码" },
          },
        ];
        return;
      }
      const index = this.messageList.length;
      this.messageList[index] = {
        type: "text",
        author: "assistant",
        data: { text: "" },
      };
      this.$store.dispatch
        .aiSignInPhoneCode(phone)
        .then(() => {
          this.phone = phone;
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: { text: "短信验证码已发送，请回复收到的验证码" },
          };
        })
        .catch((res) => {
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: {
              text:
                "" +
                this.$t(
                  "error." + (res.detail || res.text[0]).replace(/\.|'/g, "")
                ),
            },
          };
        });
    },
    login(code) {
      const index = this.messageList.length;
      this.messageList[index] = {
        type: "text",
        author: "assistant",
        data: { text: "" },
      };
      this.$store.dispatch
        .aiSignInPhone({ phone: this.phone, code })
        .then((res) => {
          this.phone = "";
          this.token = res.token;
          localStorage.setItem("ai-token", this.token);
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: { text: "登录成功" },
          };
        })
        .catch((res) => {
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: {
              text:
                "" +
                this.$t(
                  "error." + (res.detail || res.text[0]).replace(/\.|'/g, "")
                ),
            },
          };
        });
    },
    logout() {
      const index = this.messageList.length;
      this.phone = "";
      this.token = "";
      localStorage.setItem("ai-token", this.token);
      this.loading = false;
      this.messageList[index] = {
        type: "text",
        author: "assistant",
        data: { text: "退出成功" },
      };
    },
    addPrompt(text) {
      if (!this.token) {
        this.loading = false;
        this.messageList = [
          ...this.messageList,
          {
            type: "text",
            author: "assistant",
            data: { text: "请先使用手机号进行登录" },
          },
        ];
        return;
      }
      const index = this.messageList.length;
      this.messageList[index] = {
        type: "text",
        author: "assistant",
        data: { text: "" },
      };
      this.$store.dispatch
        .aiAddPrompt({ text, token: this.token })
        .then(() => {
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: { text: "添加成功" },
          };
        })
        .catch((res) => {
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: {
              text:
                "" +
                this.$t(
                  "error." + (res.detail || res.text[0]).replace(/\.|'/g, "")
                ),
            },
          };
        });
    },
    chat(message) {
      const index = this.messageList.length;
      this.messageList[index] = {
        type: "text",
        author: "assistant",
        data: { text: "" },
      };
      this.$store
        .dispatch("loader/aiChat", { message, keyboard_type: "80" })
        .then((res) => {
          if (res.change_func === "keyboardReset") {
            this.$emit("reset");
            setTimeout(() => {
              this.messageList[index] = {
                type: "text",
                author: "assistant",
                data: { text: res.reply_msg },
              };
              this.loading = false;
            }, 1000);
          } else if (res.change_json) {
            this.$store.dispatch("loader/downloadJSON", [res.change_json]);
            setTimeout(() => {
              this.$store.dispatch("loader/syncJSON");
              this.messageList[index] = {
                type: "text",
                author: "assistant",
                data: { text: res.reply_msg },
              };
              this.loading = false;
            }, 1000);
          } else {
            this.messageList[index] = {
              type: "text",
              author: "assistant",
              data: { text: res.reply_msg },
            };
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: { text: `服务异常，请稍候再进行尝试` },
          };
        });
    },
    InputText() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.text.length) {
          const firstChar = this.text.slice(0, 1);
          this.text = this.text.slice(1);
          const index = this.messageList.length - 1;
          this.messageList[index] = {
            type: "text",
            author: "assistant",
            data: {
              text: (this.messageList[index]?.data.text || "") + firstChar,
            },
          };
          this.messageList = [...this.messageList];
          if (this.text.length) {
            this.InputText();
          } else {
            this.loading = false;
          }
        }
      }, Math.floor((Math.random() * 2000) / (this.text.length + 5)));
    },
  },
  mounted() {
    this.initInput();
  },
};
</script>
<style lang="scss">
.v-chat-box {
  .sc-launcher {
    background-image: $linear-gradient;
    z-index: 9999;
  }

  .sc-chat-window {
    width: 500px;
    height: 800px;
    max-height: none;
    right: 30px;
    bottom: 150px;
    border-radius: 0;
    transition: 0.1s ease-in-out;
    z-index: 9999;

    .sc-header {
      background-image: $linear-gradient !important;
      border-radius: 0;
      padding: 5px;
      min-height: auto;

      .sc-header--title {
        font-size: 22px;
        text-align: left;
      }
    }

    .sc-header--img {
      width: 45px;
      height: 45px;
      padding: 0;
      margin: 0 5px 0 20px;
    }

    .sc-message {
      width: 90%;
      text-align: left;

      .sent .sc-message--text {
        background-image: linear-gradient(
          270deg,
          rgba(135, 67, 255, 0.7) 0%,
          rgba(65, 54, 241, 0.7) 100%
        );
        background-color: transparent !important;
      }

      .sc-message--text {
        font-size: 22px;
      }
    }

    .sc-message--text-content {
      margin: 0;
      white-space: pre-wrap;

      a {
        color: #4e8cff;
        text-decoration: underline;
      }
    }

    .sc-typing-indicator {
      padding: 10px 10px 5px 15px;
      font-size: 12px;

      span {
        width: 6px;
        height: 6px;
      }
    }

    .sc-user-input {
      border: 0;
      border-radius: 0;
      text-align: left;

      .sc-user-input--text {
        width: calc(100vw - 200px);
      }
    }
  }
}
</style>
